import { BACKEND_URL } from '../constants/server.constants';
import axiosInstance from './axios-interceptor.service';

export abstract class BaseService {
  public readonly backendUrl = BACKEND_URL;
  protected readonly axios = axiosInstance;
}
